import React from 'react'

function Loader() {
  return (
    <div className='loader'>
      Loader
    </div>
  )
}

export default Loader
